import { createAsyncThunk } from "@reduxjs/toolkit";
import { resetPasswordApi } from "./api";

export const resetPassword = createAsyncThunk(
  "resetPassword",
  async (payload) => {
    const res = await resetPasswordApi(payload);
    return res;
  }
);
